<form [formGroup]="searchForm">
  <div>
    <mat-form-field [hideRequiredMarker]="hideRequiredMarker">
      <mat-label>{{ title || "car-workshop-title" | translate }}</mat-label
      ><input
        type="text"
        matInput
        formControlName="name"
        [matAutocomplete]="auto"
        [required]="isRequired"
      />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let carWorkshop of carWorkshops$ | async"
          (onSelectionChange)="handleCarWorkshopChange($event, carWorkshop)"
          [value]="carWorkshop.tradingName"
          class="autocomplete"
        >
          {{ carWorkshop.tradingName }} - {{ carWorkshop.city }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="
          searchForm.get('name').touched &&
          searchForm.get('name').hasError('required')
        "
        >{{ requiredText || "required-car-workshop" | translate }}</mat-error
      >
    </mat-form-field>
  </div>
</form>
